import React from "react";
import NavTabs from "./NavTabs";
import Home from "./pages/Home";

export default function PortfolioContainer() {
  return (
    <div>
      <NavTabs />
      <Home />
    </div>
  );
}
